import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  notificationsMenu;
  notificationsCount: number;

  constructor () {
    if (+localStorage.getItem('notifications') === 0) {
          this.notificationsCount = +localStorage.getItem('notifications');
    } else {
          // localStorage.setItem('notifications', '1')
          this.notificationsCount = +localStorage.getItem('notifications');
      }
  }

  ngOnInit () {
    // localStorage.setItem('notifications', '1');
  }

  quitarNotificaciones() {
    this.notificationsCount = 0
    localStorage.setItem('notifications', '0');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/notifications/notifications.component.ts